module.exports = {
  PAGINATION: {
    PER_PAGE: 10,
    PAGE: 1,
  },
  BACKEND_API: process.env.REACT_APP_BACKEND_URL,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  SECRET_KEY_TOKEN: process.env.REACT_APP_SECRET_KEY_TOKEN,
  TOKEN_EXPIRES_IN: process.env.REACT_APP_TOKEN_EXPIRES_IN,
  DOMAIN_URL :process.env.REACT_APP_DOMAIN_URL,

  ADD_BALANCE_PARAMS: process.env.REACT_APP_ADD_BALANCE_PARAMS,
  CHECK_BALANCE_PARAMS: process.env.REACT_APP_CHECK_BALANCE_PARAMS,
  UPDATE_PASSOWRD_PARAMS: process.env.REACT_APP_UPDATE_PASSOWRD_PARAMS,
  GET_TRANSACTION_PARAMS: process.env.REACT_APP_GET_TRANSACTION_PARAMS,
  GET_DEAL_PARAMS: process.env.REACT_APP_GET_DEAL_PARAMS,
  REG_PARAMS: process.env.REACT_APP_REG_PARAMS,
  AED_TO_USD_RATE: process.env.REACT_APP_AED_TO_USD_RATE,

};
